import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const fadeButton = css`
  --translate-distance: 0 !important;
  position: absolute;
  top: unset;
  left: calc(50% - 38px);
  bottom: 0;
  z-index: 2;
  min-width: 70px;
  path {
    stroke-width: 2;
  }
  ${breakpoints.from.tablet} {
    display: none;
  }
`;
